





































































































































import TenantClass from '@/views/tenants/TenantClass';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class TenantForm extends Vue {
  @Prop({ default: () => new TenantClass() })
  readonly value!: TenantClass

  private form: TenantClass = new TenantClass();

  private tenantData: TenantClass = new TenantClass()
  private isMounted: boolean = false

  private mounted () {
    this.isMounted = true;
  }

  created() {
    this.form = this.value ? new TenantClass(this.value) : {};
  }

  saveChanges (): void {
    // const form = this.$refs.form;
    this.$validator.validateAll().then(async valid => {
      if (valid) {
        this.$store
          .dispatch('visitManagement/updateTenant', this.form)
          .then(function (result) {
            console.log(result);
          });
      }
    });
  }
}
